import React, { Component, Fragment } from "react";

import { Metric } from "./../Utils/Utils.js";
import Heading from "./../Elements/Heading";

class LastWeekSummary extends Component {
  render() {
    const { data, url } = this.props;

    const isPocketWatch = url.includes("pocket-watch");

    return (
      <Fragment>
        <div className="row mt-2 d-flex align-items-end">
          <div className="col-12 widget__info-text">
            <h5>
              For <b>{data.interval}</b>
            </h5>

            {!isPocketWatch && (
              <small>
                The Prior Week's Summary data is updated every Thursday at 12pm
                ET.
              </small>
            )}
          </div>

          {data.free_trial_starts && (
            <div className="col-6 col-md-2">
              <Heading size={6} className={"mb-1"}>
                Free Trials Last Week
              </Heading>
              <Metric {...data.free_trial_starts} size={"md"} />
            </div>
          )}

          {/* <div className="col-6 col-md-2 mb-3 mb-md-0">
            <Heading size={6} className={'mb-1'} >
              New Paid Subs Last Week
              </Heading>
            <Metric {...data.data.new_paid_subs} size={'md'} />
          </div> */}

          {data.net_adds && (
            <div className="col-6 col-md-2 mb-3 mb-md-0">
              <Heading size={6} className={"mb-1"}>
                Net Adds
              </Heading>
              <Metric {...data.net_adds} size={"md"} />
            </div>
          )}

          {data.cancels && (
            <div className="col-6 col-md-2">
              <Heading size={6} className={"mb-1"}>
                Cancels
              </Heading>
              <Metric {...data.cancels} size={"md"} />
            </div>
          )}

          {data.total_subs && (
            <div className="col-6 col-md-2">
              <Heading size={6} className={"mb-1"}>
                Total Subs
              </Heading>
              <Metric {...data.total_subs} size={"md"} />
            </div>
          )}
        </div>
      </Fragment>
    );
  }
}

export default LastWeekSummary;
